
















































































import { Component, Watch } from 'vue-property-decorator';
import EChart from '@/component/weather/Charts/echarts.vue';
import API from '@/Api/api_data';
import { HotTable } from '@handsontable/vue';
import 'handsontable/dist/handsontable.full.css';
import { Column, Worksheet } from 'exceljs';
import './weather.less';
import '../baidumap/css/Weather.less';
import MessageBus from '@/Utils/message/message-bus';
import NavigationInformation from '@/component/NavigationInformation/menu-item/navigation-information';
import { getQueryString } from '@/Api/api_data';
import Tools from '@/component/template/tools/tools';
import { WeatherData, WeatherData_Origin } from '@/interfaces/weather_interface';
import WeatherBase, { dataIESType, dataWeatherNewType } from './index';
import Handsontable from 'handsontable';
import { WEATHER_COLUMNS, WEATHER_HT_COLUMNS, WEATHER_COLUMNS_New, WEATHER_HT_COLUMNS_New } from '@/component/weather/weather/table-column';
import { profile } from '@/Utils/profile';
const ieslabDisableRules = profile.get('ieslabDisableRules') === 'true';
const iesDisableRules = profile.get('iesDisableRules') === 'true';

/**
 * Component
 */
@Component({
    components: {
        EChart,
        'hot-table': HotTable,
    },
})
export default class Weather extends WeatherBase {
    /** 天气表格 columns */
    columns: any[] = []; //eslint-disable-line
    /** 天气表格 handsontable  */
    ht_columns: any = []; //eslint-disable-line

    /** 旧版气象类型 */
    chartSelectListIES = Object.keys(dataIESType)
        .splice(1)
        .map((x) => {
            return {
                value: x,
                name: dataIESType[x],
            };
        });

    /** 新版气象类型 */
    chartSelectListNew = Object.keys(dataWeatherNewType)
        .splice(1)
        .map((x) => {
            return {
                value: x,
                name: dataWeatherNewType[x],
            };
        });

    /** 算例id */
    simu_id!: number;
    /** 表格数据加载延迟 */
    tableSpinning = true;
    /** 图表导航配置 */
    chartList = new NavigationInformation(this.chartSelectListIES, '环境温度（℃）');
    /** 确定按钮loading */
    confirmLoading = false;
    /** 编辑状态 */
    editFlag = false;
    /** 导出按钮loading */
    exportLoading = false;
    /** 页面loading */
    pageSpinning = false;
    /** 编辑表格数据 */
    get htSettings(): Handsontable.GridSettings {
        return {
            stretchH: 'all',
            width: '100%',
            autoWrapRow: true,
            height: 350,
            maxRows: 24,
            rowHeights: 50,
            manualRowResize: true,
            manualColumnResize: true,
            rowHeaders: true,
            manualRowMove: true,
            className: 'htCenter',
            manualColumnMove: true,
            columns: this.ht_columns,
            data: this.weather_data,
            colHeaders: Object.values(dataIESType),
            afterChange: (changes: Handsontable.CellChange[] | null, source: string): void => {
                if (!changes) return;
                if (!this.htSettings.data) return;
                if (source === 'edit' && changes[0][2] !== changes[0][3]) {
                    if (isNaN(Number(changes[0][3]))) {
                        MessageBus.Notification('error', {
                            description: '验证错误，请检查格式!',
                            message: '提示',
                        });
                        this.htSettings.data[changes[0][0]][changes[0][1]] = changes[0][2];
                    } else {
                        this.weather_data_cache.push(this.htSettings.data[changes[0][0]] as WeatherData);
                    }
                }
            },
            // 增加判断是否为批量复制后的值，传入weather_data_cache
            afterAutofill: (fillData, sourceRange, targetRange: Handsontable.wot.CellRange): void => {
                if (!this.htSettings.data) return;
                const end = targetRange.to.row;
                let start = targetRange.from.row;
                while (start <= end) {
                    const item = this.htSettings.data[start];
                    this.weather_data_cache.push(item as WeatherData);
                    start++;
                }
            },
        };
    }

    /** */
    disabledFunction = false;

    /**
     * @author guan
     * @description 加载默认数据
     * @return void
     */
    async mounted(): Promise<void> {
        const simu_id = this.$route.query.simu_id as string;
        this.getDateFunc(simu_id).catch(() => {
            this.tableSpinning = false;
        });
        await this.getWeatherData();
        if (!this.$route.name?.includes('ies')) {
            this.disabledFunction = ieslabDisableRules;
        } else {
            this.disabledFunction = iesDisableRules;
        }
    }

    /**
     * 获得当前主题
     */
    get cloudPssTheme(): string {
        return this.$store.getters.getTheme;
    }

    /**
     * 监听当前主题变化，改变页面部分样式
     */
    @Watch('cloudPssTheme')
    onThemeChange(): void {
        this.formatStatsData();
    }

    /**
     * 监听选择日期变化，重新加载页面数据
     */
    @Watch('timeData', { deep: true })
    async getWeatherDataBySelect(): Promise<void> {
        try {
            await this.getWeatherData();
            // 强制刷新htSettings表格
            this.editFlag = !this.editFlag;
            this.$nextTick(() => {
                this.editFlag = !this.editFlag;
            });
        } catch (error) {
            MessageBus.Notification('error', { message: '数据加载错误', description: '数据加载错误，请重试' });
        }
    }
    /**
     * 监听当前激活的tab
     */
    @Watch('chartList.active', { immediate: true, deep: true })
    getEChartData(): void {
        this.formatStatsData();
    }

    /**
     * @param data 旧气象数据
     */
    private toFixedData(data: WeatherData_Origin[]): Promise<WeatherData[]> {
        return new Promise((resolve) => {
            data.forEach((x) => {
                x.tsoil3 = (Number(x.tsoil3) - 273.15).toFixed(2);
                x.lwgab_swgdn = Number(x.lwgab_swgdn).toFixed(3);
                x.t10m = (Number(x.t10m) - 273.15).toFixed(3);
                x.u10m = Number(x.u10m).toFixed(3);
                x.u50m = Number(x.u50m).toFixed(3);
                x.v10m = Number(x.v10m).toFixed(3);
                x.v50m = Number(x.v50m).toFixed(3);
                x.qv10m = Number(x?.qv10m).toFixed(3);
                if (x.adj_sfc_sw_direct_all_1h) {
                    x.adj_sfc_sw_direct_all_1h = Number(x?.adj_sfc_sw_direct_all_1h).toFixed(3);
                }
                if (x.adj_sfc_sw_diff_all_1h) {
                    x.adj_sfc_sw_diff_all_1h = Number(x?.adj_sfc_sw_diff_all_1h).toFixed(3);
                }
                if (x.solar_zen_angle_1h) {
                    x.solar_zen_angle_1h = Number(x?.solar_zen_angle_1h).toFixed(3);
                }
            });
            return resolve(data);
        });
    }

    /**
     * @author guan
     * @description 获取天气数据
     * @return void
     */
    private async getWeatherData(): Promise<void> {
        this.tableSpinning = true;
        const simu_id = this.$route.query.simu_id as string;
        let year: string | number = this.timeData.year;
        let month: string | number = this.timeData.month;
        let day: string | number = this.timeData.day;
        if (this.timeData.month < 10) {
            month = `0${month}`;
        }
        if (this.timeData.day < 10) {
            day = `0${day}`;
        }
        const res = await API.getWeatherData({
            time_after: `${year}-${month}-${day}`,
            time_before: `${year}-${month}-${day}`,
            sid: simu_id,
        });
        const results = await this.toFixedData(res.results);
        if (results.length === 0) {
            this.tableSpinning = false;
            this.columns = WEATHER_COLUMNS_New;
            this.weather_data = [];
            this.htSettings.data = this.weather_data;
            this.ht_columns = WEATHER_HT_COLUMNS;
        } else {
            this.weather_coordinates = {
                lat: res.results[0].lat,
                lng: res.results[0].lng,
            };
            if (!res.results[0]['adj_sfc_sw_direct_all_1h'] && !res.results[0]['adj_sfc_sw_diff_all_1h'] && !res.results[0]['solar_zen_angle_1h']) {
                this.columns = WEATHER_COLUMNS;
                this.ht_columns = WEATHER_HT_COLUMNS;
                this.chartList = new NavigationInformation(this.chartSelectListIES, '环境温度（℃）');
            } else {
                this.columns = WEATHER_COLUMNS_New;
                this.ht_columns = WEATHER_HT_COLUMNS_New;
                this.chartList = new NavigationInformation(this.chartSelectListNew, '环境温度（℃）');
            }
            this.weather_data = results;
            this.tableSpinning = false;
            this.htSettings.data = this.weather_data;
            this.formatStatsData();
        }
    }

    /**
     * @author guan
     * @description 编辑更新天气数据方法
     * @return void
     */
    updateWeatherData(data: WeatherData[]): void {
        const allRequests = data.map((x) => {
            let xx = { ...x };
            xx.time = `${xx.time}`;
            xx.tsoil3 = (Number(x.tsoil3) + 273.15).toString();
            xx.t10m = (Number(x.t10m) + 273.15).toString();
            return API.updateWeatherData(xx);
        });
        Promise.all(allRequests)
            .then(() => {
                this.$notification.success({ message: '成功', description: '更新数据成功' });
            })
            .catch(() => {
                this.$notification.error({ message: '失败', description: '更新数据失败' });
            });
    }

    /**
     * 上传天气数据方法
     */
    async postWeatherData(item: WeatherData[]): Promise<void> {
        try {
            await API.postWeatherData({ data: item, sid: Number(getQueryString()['simu_id']) }, {});
            await this.getWeatherData();
            this.$notification.success({ message: '成功', description: '上传数据成功' });
        } catch {
            this.$notification.error({ message: '失败', description: '上传数据失败' });
        } finally {
            this.pageSpinning = false;
        }
    }
    /**
     * @author guan
     * @description 格式化数据
     * @return void
     */
    formatStatsData(): void {
        this.weatherOption.yAxis = [];
        this.weatherOption.series = [];
        /** 生成对应配置 */
        const yData = {
            type: 'value' as 'value' | 'category' | 'time' | 'log',
            name: this.chartList.active,
            nameTextStyle: {
                color: this.cloudPssTheme === 'dark' ? '#ffffff' : '#000',
            },
            axisLabel: {
                formatter: '{value}',
                color: this.cloudPssTheme === 'dark' ? '#ffffff' : '#000',
            },
            splitLine: {
                show: false,
            },
        };
        let chartSelectList: any = []; //eslint-disable-line
        if (this.weather_data.length === 0) {
            chartSelectList = this.chartSelectListIES;
        } else {
            if (!this.weather_data[0]['adj_sfc_sw_direct_all_1h']) {
                chartSelectList = this.chartSelectListIES;
            } else {
                chartSelectList = this.chartSelectListNew;
            }
        }
        // const chartSelectList = this.chartSelectListIES;
        const info = chartSelectList.find((x) => {
            return x.name === this.chartList.active;
        });
        if (!info) {
            void this.$message.error({ content: `未找到 ${this.chartList.active} 的天气数据` });
            throw new Error(`no find ${this.chartList.active}`);
        }
        const getData = this.weather_data.map((x) => {
            return x[info.value];
        });

        const xAxis = this.weather_data.map((x) => {
            return x.time;
        });

        /** 加载数据 */
        this.weatherOption.yAxis = yData;
        this.weatherOption.xAxis.axisLabel = { color: this.cloudPssTheme === 'dark' ? '#ffffff' : '#000' };
        this.weatherOption.xAxis.data = xAxis;
        this.weatherOption.series.push({
            name: this.chartList.active,
            type: 'line',
            data: getData,
        });
    }
    /**
     * @author guan
     * @description 下载模板
     * @return void
     */
    async download(): Promise<void> {
        await Tools.init('天气气象数据', undefined, undefined, (Worksheet: Worksheet) => {
            return this.initStyle(Worksheet);
        });
    }
    /**
     * @author guan
     * @description 初始化
     * @return void
     * @param Worksheet
     */
    async initStyle(Worksheet: Worksheet): Promise<Worksheet> {
        this.exportLoading = true;
        let chartSelectList = this.chartSelectListIES;
        if (this.weather_data.length === 0) {
            chartSelectList = this.chartSelectListIES;
        } else {
            if (!this.weather_data[0]['adj_sfc_sw_direct_all_1h']) {
                chartSelectList = this.chartSelectListIES;
            } else {
                chartSelectList = this.chartSelectListNew;
            }
        }
        const columns: Array<Partial<Column>> = chartSelectList.map((x) => {
            return { header: x.name, key: x.value, width: 16 };
        });
        columns.unshift({ header: '日期', key: 'time', width: 32 });
        Worksheet.columns = columns;
        let data: WeatherData[];
        try {
            const res = await API.getWeatherData({
                sid: getQueryString()['simu_id'],
                size: 52608,
            });
            data = await this.toFixedData(res.results);
            Worksheet.addRows(data);
            this.exportLoading = false;
            this.$notification.success({ message: '成功', description: '导出数据成功' });
            return Worksheet;
        } catch {
            this.exportLoading = false;
            this.$notification.error({ message: '失败', description: '导出数据失败' });
            return Worksheet;
        }
    }

    /**
     * @author: guan
     * @description: 上传数据
     */
    async uploadExcel(): Promise<void> {
        /** 目标文件，暂不支持多选 */
        const file = await Tools.userUpload();
        if (file == null) {
            return;
        }
        if (file.name.split('.').pop() !== 'xlsx' && file.name.split('.').pop() !== 'xls') {
            MessageBus.Notification('warning', { description: '请选择上传的文件类型为XLSX或XLS', message: '提示' });
            return;
        }
        this.pageSpinning = true;
        const columns = this.ht_columns.map((x) => {
            return x.title;
        });
        const data = await Tools.loadDataByExcel(file);
        const headers = data[0];
        for (const item of headers) {
            if (!columns.includes(item)) {
                MessageBus.Notification('error', { description: 'excel表格表头数据有误！', message: '提示' });
                this.pageSpinning = false;
                return;
            }
        }
        const dataList = data.slice(1);
        dataList.forEach((item, index) => {
            const isValidateDate = this.validateDate(item[0]);
            if (!isValidateDate) {
                MessageBus.Notification('error', {
                    description: `第${index + 2}行，日期列数据格式有误或数据非法，正确格式为YYYY-MM-DD hh:mm:ss！`,
                    message: `提示`,
                    duration: 4,
                });
                this.pageSpinning = false;
                return;
            }

            const list = item.slice(1);
            list.forEach((v, i) => {
                if (isNaN(Number(v)) || v === '') {
                    MessageBus.Notification('error', {
                        description: `第${index + 2}行${i + 2}列，数据格式错误！`,
                        message: '提示',
                        duration: 4,
                    });
                    this.pageSpinning = false;
                    return;
                }
            });
        });
        if (!columns.includes('短波直射强度（W/m²）')) {
            const arr = dataList.map((item) => {
                return {
                    sid: getQueryString()['simu_id'],
                    lat: this.weather_coordinates.lat,
                    lng: this.weather_coordinates.lng,
                    time: item[0],
                    t10m: (Number(item[1]) + 273.15).toString(),
                    lwgab_swgdn: item[2],
                    tsoil3: (Number(item[3]) + 273.15).toString(),
                    u10m: item[4],
                    u50m: item[5],
                    v10m: item[6],
                    v50m: item[7],
                };
            });
            void this.postWeatherData(arr as unknown as WeatherData[]);
        } else {
            const arr = dataList.map((item) => {
                return {
                    sid: getQueryString()['simu_id'],
                    lat: this.weather_coordinates.lat,
                    lng: this.weather_coordinates.lng,
                    time: item[0],
                    t10m: (Number(item[1]) + 273.15).toString(),
                    lwgab_swgdn: item[2],
                    u10m: item[3],
                    u50m: item[4],
                    v10m: item[5],
                    v50m: item[6],
                    adj_sfc_sw_direct_all_1h: item[7],
                    adj_sfc_sw_diff_all_1h: item[8],
                    solar_zen_angle_1h: item[9],
                };
            });
            void this.postWeatherData(arr as unknown as WeatherData[]);
        }
    }

    /**
     * 日期合法性校验
     * 合法格式为YYYY-MM-DD hh:mm:ss
     * new Date()构造函数会为不合理的日期参数做进位运算，如：new Date('2019-02-29 00:00:00').getDate() === 1
     */
    validateDate(str: string): boolean {
        const date = new Date(str);
        const day = date.getDate();
        const valid = /^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/;
        if (isNaN(Number(date))) {
            return false;
        }
        if (!valid.test(str)) {
            return false;
        }
        if (day !== Number(str.slice(8, 10))) {
            return false;
        } else {
            return true;
        }
    }

    /**
     * 编辑表格
     */
    editTable(checked: boolean): void {
        this.editFlag = checked;
        if (!checked) {
            if (this.weather_data_cache.length > 0) {
                this.updateWeatherData(this.weather_data_cache);
                this.formatStatsData();
            }
        } else {
            this.htSettings.data = this.weather_data;
            this.weather_data_cache = [];
        }
    }

    /**
     * 获得日期
     */
    async getDateFunc(simu_id: string): Promise<void> {
        const params = {
            simu_id: Number(simu_id),
        };
        const res = await API.loadDateData(params);
        let startYear = Number(res.firstTime.substring(0, 4));
        const lastYear = Number(res.lastTime.substring(0, 4));
        this.yearSource = [];
        while (startYear <= lastYear) {
            this.yearSource.push({
                value: startYear,
                label: `${startYear++}年`,
            });
        }
        const lastTime = Number(res.lastTime.substring(5, 7));
        this.monthSource = [
            ...new Array(lastTime).fill('').map((_x, index) => {
                return { value: index + 1, label: `${index + 1}月` };
            }),
        ];
    }
}
